import withController from 'components/common/form-controlled/with-controller.hoc';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import RadioButtons from 'components/common/radio-buttons';
import type { RadioButtonsProps } from 'components/common/radio-buttons';

export default withLabel(withController<RadioButtonsProps>(RadioButtons));
